export default __webpack_public_path__ + "static/media/category_20.dedf2c0f.png";